// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"ffd7f636","697":"df724974","944":"97a7a7e5"}[chunkId] + ".chunk.css";
};